export default __webpack_public_path__ + "static/media/logo_large.fc38af51.svg";